import { Anchor } from "@mantine/core";
import { useAppDispatch } from "../app/hooks";
import { setArticleDetailsNumber } from "../DrofusOccurrenceValidation/drofusOccurrenceValidationSlice";

export function ArticleNumberLink({ value }: { value?: string | null }) {
  const dispatch = useAppDispatch();
  if (!value) return <span>–</span>;
  return <Anchor component="button" type="button" size="sm" onClick={event => {
    event.stopPropagation();
    dispatch(setArticleDetailsNumber(value));
  }}>{value}</Anchor>;
}
